import QuickPickQuestion from "./QuickPickQuestion";

export default QuickPickQuestion;